import axios from "axios"
import Cookies from "js-cookie"
import host from "./host"
const PORTAL_USUARIOS_MODULE_ID = 1
const host_dashboard = 'https://api-myoplay-hml.solvel.tech'

//paths
const path = {
    auth: "/api/auth",
    users: "/api/users",
    patient: "/api/patients",
    dentist: "/api/dentists",
    client: "/api/client",
    dialy_controls: "/api/dialy_controls",
    controls: "/api/controls",
    status_history: "/api/status_history",
    holiday: "/api/holiday",
    administrator_dashboard: "/api/administrator_dashboard",
    dashboards: "/api/dashboards",
    patient_delete_history: "/api/patient_delete_history",
    auth_patient: "/api/auth-patient",
    configs: "/api/configs",
    protocols: "/api/protocol",
    exercise: "/api/exercises",
    patient_protocol: "/api/patient_protocol",
    protocol_exercise: "/api/protocol_exercise",
}

export default {
    auth: {
        simpleLogin: body => {
            return axios.post(`${host}${path.auth}/authenticate`, body)
        },
        forgotPassword: email => {
            return axios.get(`${host}${path.auth}/forgot-password`, { params: { email } })
        },
        changePassword: body => {
            return axios.put(`${host}${path.auth}/change-password/${body.id}`, body);
        },
        changePasswordForced: body => {
            return axios.put(`${host}${path.auth}/change-password-forced/${body.id}`, body);
        },

        changeActive: body => {
            return axios.put(`${host}${path.client}/change-active/${body.id}`, body)
        },
        listUsers: () => {
            return axios.get(`${host}${path.auth}/`);
        },
        setAuthorizationToken: async (formatedToken) => {
            axios.defaults.headers.common.Authorization = formatedToken
            await localStorage.setItem('token', formatedToken)
            return
        },
        removeAuthorizationToken: async () => {
            axios.defaults.headers.common.Authorization = null
            await localStorage.removeItem('token')
            return
        },
        getEnums: params => {
            return axios.get(`${host}/api/enums`, { params });
        },
        resetPassword: body => {
            return axios.put(`${host}${path.auth}/change-password`, body);
        },
        forceResetPassword: body => {
            return axios.post(`${host}${path.auth}/reset-password`, body);
        }
    },
    auth_patient: {
        forgotPassword: email => {
            return axios.get(`${host}${path.auth_patient}/forgot-password`, { params: { email } })
        },
    },
    user: {
        update: body => {
            return axios.put(`${host}${path.auth}/${body.id}`, body)
        },
        create: body => {
            return axios.post(`${host}${path.auth}`, body)
        },
        list: params => {
            return axios.get(`${host}${path.auth}/list`, { params });
        },
        get: userId => {
            return axios.get(`${host}${path.auth}/${userId}`)
        },
        changeStatus: body => {
            return axios.post(`${host}${path.users}/changeStatus/${body.id}`, body);
        },
        updateLanguage: body => {
            return axios.post(
                `${host}${path.users}/updateLanguage/${body.id}`, 
                body, 
                {
                    headers: {
                        Authorization: body.token
                    }
                }
            );
        },
        exclude: id => {
            return axios.delete(`${host}${path.users}/${id}`)
        },

    },
    patient: {
        update: body => {
            return axios.put(`${host}${path.patient}/${body.id}`, body)
        },
        create: body => {
            return axios.post(`${host}${path.patient}`, body)
        },
        listMangos: params => {
            return axios.get(`${host}${path.patient}/${params?.id}/mangoHistory/${params?.page}`, { params });
        },
        list: params => {
            return axios.get(`${host}${path.patient}`, { params });
        },
        get: patient_id => {
            return axios.get(`${host}${path.patient}/${patient_id}`)
        },
        sendReport: body => {
            return axios.post(`${host}${path.patient}/${body?.id}/sentReport`, body)
        },
        toggleToExclude: id => {
            return axios.post(`${host}${path.patient}/${id}/toExcludeToggle`)
        },
        gainMangos: body => {
            return axios.post(`${host}${path.patient}/${body?.id}/gainMangos`, body)
        },
        spendMangos: body => {
            return axios.put(`${host}${path.patient}/${body?.id}/useMangos`, body)
        },
        exclude: id => {
            return axios.delete(`${host}${path.patient}/${id}`)
        },
        listForSelectOptions: params => {
            return axios.get(`${host}${path.patient}/listSelectOptions`, { params });
        },
    },
    dashboards: {
        findEvoMonitoryChart: params => {
            return axios.get(`${host_dashboard}${path.dashboards}/evo-monitory-chart`, { params })
        },
        findEvoExerciseChart: params => {
            return axios.get(`${host_dashboard}${path.dashboards}/evo-exercise-chart`, { params })
        },
        findEvoGroupingChart: params => {
            return axios.get(`${host_dashboard}${path.dashboards}/evo-grouping-chart`, { params })
        },
        findGroupingLevelChart: params => {
            return axios.get(`${host_dashboard}${path.dashboards}/grouping-level-chart`, { params })
        },
        findPatientScoreChart: params => {
            return axios.get(`${host_dashboard}${path.dashboards}/patient-score-chart`, { params })
        },
    },
    patient_delete_history: {
        list: params => {
            return axios.get(`${host}${path.patient_delete_history}`, { params })
        }
    },
    dentist: {
        recover: body => {
            return axios.post(`${host}${path.users}/dentist/restore/${body.id}`, body)
        },
        update: body => {
            return axios.put(`${host}${path.auth}/dentist/${body.id}`, body)
        },
        create: body => {
            return axios.post(`${host}${path.auth}/dentist`, body)
        },
        list: params => {
            return axios.get(`${host}${path.users}/dentists`, { params });
        },
        get: dentist_id => {
            return axios.get(`${host}${path.users}/dentists/${dentist_id}`)
        },
    },
    monitor: {
        update: body => {
            return axios.put(`${host}${path.auth}/monitor/${body.id}`, body)
        },
        create: body => {
            return axios.post(`${host}${path.auth}/monitor`, body)
        },
        list: params => {
            return axios.get(`${host}${path.users}/monitors`, { params });
        },
        get: monitor_id => {
            return axios.get(`${host}${path.users}/monitors/${monitor_id}`)
        },
        getCurrent: () => {
            return axios.get(`${host}${path.dialy_controls}/currentMonitors`);
        },
        listStatuHistory: params => {
            return axios.get(`${host}${path.status_history}/list`, { params })
        }
    },
    dialy_controls: {
        update: body => {
            return axios.put(`${host}${path.dialy_controls}/update`, body)
        },
        addEvent: body => {
            return axios.put(`${host}${path.dialy_controls}/add/${body.id}`, body)
        },
        removeEvent: body => {
            return axios.put(`${host}${path.dialy_controls}/remove/${body.id}`, body)
        },
        create: body => {
            return axios.post(`${host}${path.dialy_controls}`, body)
        },
        createInExercise: (body,id) => {
            return axios.post(`${host}${path.dialy_controls}/inExercise/${id}`, body)
        },
        list: params => {
            return axios.get(`${host}${path.dialy_controls}/`, { params });
        },
        listCurrents: () => {
            return axios.get(`${host}${path.dialy_controls}/listCurrents`);
        },
        listExercising: () => {
            return axios.get(`${host}${path.dialy_controls}/listExercising`);
        },
        listWaiting: () => {
            return axios.get(`${host}${path.dialy_controls}/listWaiting`);
        },
        find: id => {
            return axios.get(`${host}${path.dialy_controls}/${id}`)
        },
        get: dialy_controls_id => {
            return axios.get(`${host}${path.dialy_controls}/${dialy_controls_id}`)
        },
        end: body => {
            return axios.put(`${host}${path.dialy_controls}/end`, body)
        },
        pause: body => {
            return axios.put(`${host}${path.dialy_controls}/pause`, body)
        },
        resume: body => {
            return axios.put(`${host}${path.dialy_controls}/resume`, body)
        },
        listControl: params => {
            return axios.get(`${host}${path.controls}`, { params });
        },
        listControlGrouped: params => {
            return axios.get(`${host}${path.controls}/group`, { params });
        },
        findControl: id => {
            return axios.get(`${host}${path.controls}/${id}`);
        },
        addComment: (id, body) => {
            return axios.put(`${host}${path.dialy_controls}/${id}/comment`, body)
        },
        cancel: (id, body) => {
            return axios.post(`${host}${path.dialy_controls}/delete/${id}`, body)
        },
        sendToExerciseRoom: (id, body) => {
            return axios.post(`${host}${path.dialy_controls}/toExercise/${id}`, body)
        },
        sendToWaitingRoom: (id, body) => {
            return axios.post(`${host}${path.dialy_controls}/toWaiting/${id}`, body)
        },
        cancelWaitingRoom: (id, body) => {
            return axios.post(`${host}${path.dialy_controls}/cancelWaiting/${id}`, body)
        },
        finishExrcise: (id, body) => {
            return axios.post(`${host}${path.dialy_controls}/finishExrcise/${id}`, body)
        },
        resumeEndedDialy: (id, body) => {
            return axios.post(`${host}${path.dialy_controls}/resume/${id}`, body)
        },
        exchangeMonitor: (id, body) => {
            return axios.post(`${host}${path.dialy_controls}/exchangeMonitor/${id}`, body)
        },
        listEnded: params => {
            return axios.get(`${host}${path.dialy_controls}/listEnded`, { params });
        },
    },
    client: {
        update: body => {
            return axios.put(`${host}${path.client}/${body.id}`, body)
        },
        create: body => {
            return axios.post(`${host}${path.client}`, body)
        },
        listClients: params => {
            return axios.get(`${host}${path.client}/list/${params}`);
        },
        get: userId => {
            return axios.get(`${host}${path.client}/${userId}`)
        },
        changeActive: body => {
            return axios.put(`${host}${path.client}/change-active/${body.id}`, body)
        },
        list: () => {
            return axios.get(`${host}${path.client}/`);
        },
    },
    holiday: {
        listHolidays: params => {
            return axios.get(`${host}${path.holiday}`, { params });
        },
        find: (id, params) => {
            return axios.get(`${host}${path.holiday}/${id}`, { params });
        },
        createNew: body => {
            return axios.post(`${host}${path.holiday}`, body);
        },
        update: (id, body) => {
            return axios.put(`${host}${path.holiday}/${id}`, body);
        },
        delete: id => {
            return axios.delete(`${host}${path.holiday}/${id}`);
        }
    },
    control: {
        listComments: id => {
            return axios.get(`${host}${path.controls}/list-coments/${id}`);
        },
        listExercises: params => {
            return axios.get(`${host}${path.controls}/exercises`, { params });
        },
        listControlsTabs: params => {
            return axios.get(`${host}${path.controls}/tabs`, { params });
        },
        findControl: id => {
            return axios.get(`${host}${path.controls}/details/${id}`);
        },
    },
    administrator_dashboard: {
        findDentistsWithPatients: params => {
            return axios.get(`${host_dashboard}${path.administrator_dashboard}/find-dentists-with-patients`, { params });
        },

        findActivePatientsHour: params => {
            return axios.get(`${host_dashboard}${path.administrator_dashboard}/find-active-patients-hour`, { params });
        }
    },
    config: {
        getRuleConfig: params => {
            return axios.get(`${host}${path.configs}`, { params });
        },

        updateRuleConfig: body => {
            return axios.post(`${host}${path.configs}/updateRuleConfig`, body);
        }
    },
    protocols: {
        listProtocols: params => {
            return axios.get(`${host}${path.protocols}`, { params });
        },
        listProtocolsByTarget: params => {
            return axios.get(`${host}${path.protocols}/target`, { params });
        },
        findWithExercises: (id, params) => {
            return axios.get(`${host}${path.protocols}/${id}`, { params });
        },
        create: body => {
            return axios.post(`${host}${path.protocols}`, body);
        },
        update: (id, body) => {
            return axios.put(`${host}${path.protocols}/${id}`, body);
        },
        delete: id => {
            return axios.delete(`${host}${path.protocols}/${id}/inactivate`);
        },

    },
    exercise: {
        listExercises: params => {
            return axios.get(`${host}${path.exercise}`, { params });
        },
        list: params => {
            return axios.get(`${host}${path.exercise}`, { params });
        },
        update: (id, body) => {
            return axios.put(`${host}${path.exercise}/${id}`, body, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
          }
          ,
        create: body => {
            return axios.post(`${host}${path.exercise}`, body)
        },
        delete: id => {
            return axios.delete(`${host}${path.exercise}/${id}`);
        },
        download: (id,file, query = {}, options = {}) => {
            return axios.get(`${host}${path.exercise}/download/exercises/${id}/attachment/${file}`, {
              params: query,
              responseType: 'blob',
              ...options,  
            });
          },  
        listForSelectOptions: params => {
            return axios.get(`${host}${path.exercise}/list-select-options`, { params })
        },
        get: exercise_id => {
            return axios.get(`${host}${path.exercise}/${exercise_id}`);

        },
        delete: id => {
            return axios.delete(`${host}${path.exercise}/${id}/inactivate`);
        }
    },
    patient_protocol: {
        getPatientProtocolByID: id =>{
            return axios.get(`${host}${path.patient_protocol}/${id}/find-protocol`)
        },
        getProtocolsByPatient: params =>{
            return axios.get(`${host}${path.patient_protocol}/patientProtocols`,{params})
        },
        createPatientProtocol : (id, body)=>{
            return axios.post(`${host}${path.patient_protocol}/${id}/protocols`, body)
        },
        updatePatientProtocol: (id, body) => {
            return axios.put(`${host}${path.patient_protocol}/${id}/update-protocol`, body)
        },
        listPatientProtocolExercises: params =>{
            return axios.get(`${host}${path.patient_protocol}/list-patient-protocol-exercises`,{params})
        }, 
        listPatientProtocols: params => {
            return axios.get(`${host}${path.exercise}/list-patient-protocols`, { params })
        },
        deletePatientProtocol: (body)=>{
            return axios.delete(`${host}${path.patient_protocol}/delete-patient-protocol`, { data: body })
        }
    },
    exercise_protocol:{
        getExercisesByProtocol: id =>{
            return axios.get(`${host}${path.protocol_exercise}/list-protocol-exercises/${id}`)
        },
        listAllPatientExercises: id =>{
            return axios.get(`${host}${path.protocol_exercise}/${id}/list-all-patient-exercises`)
        }
    }
}
